<template>
    <VContainer>
        <BaseCard v-if="event && !$store.state.activesku">
            <VCardTitle class="headline font-weight-light" >
                {{this.event.event.name}}
            </VCardTitle>
            <VCardText >
                <VLayout wrap>
                    <VFlex>
                        <img :src="this.event.event.imgurl" :height="200" />
                    </VFlex>
                    <VFlex>
                        {{this.event.event.description}}
                    </VFlex>
                </VLayout>
                <VLayout wrap>
                    <VFlex xs12>
                        <span class="title font-weight-light">Select to register</span>
                        <v-list>
                            <v-list-item v-for="(a,i) in event.skus" @click="selectSku(a)" :key="i" >
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{a.attributes.name}} ${{a.price/100}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle v-if="current<$store.state.maxteams">
                                        {{a.metadata.date}}  {{a.metadata.time}}
                                    </v-list-item-subtitle>
                                    <v-list-item-title v-else>
                                        FULL
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn icon v-if="current<$store.state.maxteams">
                                        <v-icon>
                                            {{$store.state.icons.checkon}}
                                        </v-icon>
                                    </v-btn>
                                    <v-btn icon  v-else>
                                        <v-icon>
                                            fa fa-check-circle
                                        </v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    {{current}}/{{$store.state.maxteams}}
                                   <v-progress-linear color="success" top :value="current/$store.state.maxteams*100"></v-progress-linear>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </VFlex>
                </VLayout>
            </VCardText>
            <VCardActions>

            </VCardActions>
        </BaseCard>
        <v-stepper v-else-if="event && $store.state.activesku" v-model="step"  >
            <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1" @click="">Players</v-stepper-step>
                <v-stepper-step :complete="step > 2" step="2">Confirm</v-stepper-step>
                <v-stepper-step :complete="step > 3" step="3">Pay</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content step="1">
                    <TourneyRegistration v-if="event.event.eventtype==='tourney' && $store.state.step===1" :sku="$store.state.activesku" />
                </v-stepper-content>
                <v-stepper-content step="2">
                    <TeamCard v-if="$store.state.step===2" :sku="$store.state.activesku" />
                </v-stepper-content>
                <v-stepper-content step="3">
                    <ConfirmRegistration v-if="$store.state.step===3" />
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
        <VCard v-if="$store.state.activesku">
            <VCardActions>
                <v-btn text v-if="step>1" @click="$store.commit('setRegistrationStep',step-1)">
                    <v-icon class="mr-2">fa fa-arrow-circle-left</v-icon>
                    Back
                </v-btn>
                <v-btn text v-if="step===1" @click="selectSku(false)">
                    <v-icon>{{$store.state.icons.home}}</v-icon>
                </v-btn>
            </VCardActions>
        </VCard>
        <v-btn v-if="$store.state.activesku" fab bottom right fixed color="black" class="white--text" @click="selectSku(false)">
            <v-icon>{{$store.state.icons.home}}</v-icon>
        </v-btn>
    </VContainer>
</template>

<script>
  import {
    mapActions,
    mapMutations,
    mapState
  } from 'vuex'
  import BaseBtn from "../BaseBtn";
  import TourneyRegistration from "../registration/TourneyRegistration";
  import TeamCard from "../registration/TeamCard";
  import ConfirmRegistration from "../registration/ConfirmRegistration";
  export default {
    props:['eventid'],
    components: {ConfirmRegistration, TeamCard, TourneyRegistration, BaseBtn},
    name: "EventById",
    data() {
      return {
        loading:false,
        activeplan:0,
        activesubscription:false,
        confirmsubscribedialog:false,
        unsubscribedialog:false
      }
    },
    mounted() {
      if(this.$store.state.customer===undefined){
        this.getCustomer()
      }
      this.getEvent()
    },
    computed:{
      ...mapState(['event','orders','registration','activesku']),
      step(){
        return this.$store.state.step
      },
      full(){
        let s = this.$store.state.activesku;
        return (this.registration['sku_GApVOGjqO8rCpa'] && this.registration['sku_GApVOGjqO8rCpa'].teams.length >this.$store.state.maxteams)
      },
      current(){
        let s = this.$store.state.activesku;
        if(this.registration['sku_GApVOGjqO8rCpa']){
          return this.registration['sku_GApVOGjqO8rCpa'].teams.length
        } else {
          return 0
        }
      }
    },
    watch:{
      customer(){
        this.loading = false
      },
      event(n,o){
        if(n){
          this.skus = n.skus
        }
      }
    },
    methods: {
      ...mapActions(['getCustomer']),
      getEvent() {
        let em = this;
        this.$store.dispatch('openGet',{body:'',path: 'api/event/json/'+this.eventid})
            .then(res=>{
              em.$store.commit('setEvent', res)
            }).catch(e=>{console.log(e)})
      },
      selectSku(s){
        if(this.current>=this.$store.state.maxteams)return;
        if(this.registration[s.id] && this.registration[s.id].teams.length >23) return
        this.$store.commit('setActiveSku',s)
      }
    }
  }
</script>

<style scoped>

</style>